// extracted by mini-css-extract-plugin
export default {"heading":"case-module--heading--2-xEA","headingContainer":"case-module--heading-container--LE5xN","title":"case-module--title--cnLAZ"};